import React from 'react'
import { Field } from 'react-final-form'
import PropTypes from 'prop-types'

import Utils from 'Utils'

import FileInput from './FileInput'

import { Label } from '../styles'

function FileInputField({ name, checkErrorIfDirty, displayError, ...rest }) {
  return (
    <Field name={name}>
      {({ input, meta }) => {
        const { hasError, error } = Utils.Form.hasError(meta, checkErrorIfDirty)

        return (
          <>
            <FileInput error={error} {...input} {...rest} />
            {displayError && hasError && (
              <Label error mt={1}>
                {error}
              </Label>
            )}
          </>
        )
      }}
    </Field>
  )
}

FileInputField.defaultProps = {
  checkErrorIfDirty: false,
  displayError: true,
  entityId: null,
}

FileInputField.propTypes = {
  checkErrorIfDirty: PropTypes.bool,
  displayError: PropTypes.bool,
  entityId: PropTypes.string,
  name: PropTypes.string.isRequired,
  uploadType: PropTypes.oneOf(['menuItemImage']).isRequired,
}

export default FileInputField
